import React, { Component } from "react";
import { Upload, Select, Input, Tooltip, message, Empty } from "antd";
import { InboxOutlined, DeleteOutlined, EyeOutlined, FileOutlined, FilePdfOutlined } from "@ant-design/icons";
import { SegmentedItem, ButtonItem } from "../../../../Components/Items";
import { ETIQUETAS_ANEXO } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

// Anexos de tickets y servicios: se arrastran varios archivos de una vez y cada uno
// lleva su etiqueta (Antes · Durante · Después · Documentación). Controlado
// (value / onChange) para usarse dentro de un FormItem.
//
// Cada elemento: existente { _id, etiqueta, nombre, archivo: { name, url, urlRelativa } }
//                nuevo     { uid, name, originFileObj, etiqueta, nombre, preview }
class AnexosCMMS extends Component {
    state = { etiquetaNuevos: this.props.etiquetaDefault || "Antes" };

    lista = () => this.props.value || [];

    cambiar = (nueva) => this.props.onChange && this.props.onChange(nueva);

    agregar = (file) => {
        const limite = this.props.limiteMb || 20;
        if (file.size / 1024 / 1024 >= limite) {
            message.error(`"${file.name}" pesa más de ${limite}MB`);
            return Upload.LIST_IGNORE;
        }
        const esImagen = /^image\//.test(file.type);
        const nuevo = {
            uid: file.uid,
            name: file.name,
            nombre: file.name.replace(/\.[^.]+$/, ""),
            originFileObj: file,
            etiqueta: this.state.etiquetaNuevos,
            preview: esImagen ? URL.createObjectURL(file) : null,
        };
        // setState funcional del padre no existe aqui: se agrega sobre la lista actual.
        this.pendientes = [...(this.pendientes || this.lista()), nuevo];
        clearTimeout(this.temporizador);
        this.temporizador = setTimeout(() => {
            this.cambiar(this.pendientes);
            this.pendientes = null;
        }, 0);
        return false;
    };

    actualizar = (indice, campo, valor) => this.cambiar(this.lista().map((a, i) => (i === indice ? { ...a, [campo]: valor } : a)));

    quitar = (indice) => this.cambiar(this.lista().filter((_, i) => i !== indice));

    url = (a) => (a.originFileObj ? a.preview : a.archivo?.url);

    esImagen = (a) => (a.originFileObj ? !!a.preview : /\.(png|jpe?g|webp|gif)$/i.test(a.archivo?.url || ""));

    render() {
        const lista = this.lista();
        const { disabled } = this.props;
        return (
            <div>
                {!disabled && (
                    <>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
                            <span style={{ fontSize: 12, color: "#4a5866" }}>Etiqueta para los archivos que agregue:</span>
                            <SegmentedItem
                                options={ETIQUETAS_ANEXO.map((e) => ({ label: e, value: e }))}
                                value={this.state.etiquetaNuevos}
                                onChange={(etiquetaNuevos) => this.setState({ etiquetaNuevos })}
                            />
                        </div>
                        <Upload.Dragger className="cmms-dragger" multiple showUploadList={false} accept={this.props.accept || ".pdf,image/*"} beforeUpload={this.agregar}>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Arrastre fotos o documentos aquí, o haga clic</p>
                            <p className="ant-upload-hint">Se agregan con la etiqueta “{this.state.etiquetaNuevos}”; puede cambiarla en cada uno.</p>
                        </Upload.Dragger>
                    </>
                )}
                {lista.length === 0 ? (
                    disabled ? <Empty description="Sin anexos" image={Empty.PRESENTED_IMAGE_SIMPLE} /> : null
                ) : (
                    <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                        {lista.map((a, i) => (
                            <div key={a._id || a.uid || i} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: "1px solid #eef1f4", borderRadius: 6, padding: 6 }}>
                                <div style={{ width: 44, height: 44, flex: "0 0 44px", borderRadius: 4, overflow: "hidden", background: "#f4f6f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    {this.esImagen(a) ? (
                                        <img src={this.url(a)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    ) : /\.pdf$/i.test(a.name || a.archivo?.url || "") ? (
                                        <FilePdfOutlined style={{ fontSize: 22, color: "#d64545" }} />
                                    ) : (
                                        <FileOutlined style={{ fontSize: 22, color: "#7a8794" }} />
                                    )}
                                </div>
                                <Input
                                    size="small"
                                    value={a.nombre}
                                    disabled={disabled}
                                    placeholder="Nombre"
                                    onChange={(e) => this.actualizar(i, "nombre", e.target.value)}
                                    style={{ flex: 1 }}
                                />
                                <Select size="small" value={a.etiqueta} disabled={disabled} style={{ width: 140 }} onChange={(v) => this.actualizar(i, "etiqueta", v)}>
                                    {ETIQUETAS_ANEXO.map((e) => (
                                        <Option key={e} value={e}>
                                            {e}
                                        </Option>
                                    ))}
                                </Select>
                                {this.url(a) && (
                                    <Tooltip title="Ver">
                                        <a href={this.url(a)} target="_blank" rel="noopener noreferrer">
                                            <ButtonItem type="default" size="small" htmlType="button" icon={<EyeOutlined />} />
                                        </a>
                                    </Tooltip>
                                )}
                                {!disabled && (
                                    <Tooltip title="Quitar">
                                        <ButtonItem type="default" size="small" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.quitar(i)} />
                                    </Tooltip>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default AnexosCMMS;
